import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\"><defs><style></style></defs><path d=\"M512 1024C229.222 1024 0 794.778 0 512S229.222 0 512 0s512 229.222 512 512-229.222 512-512 512zm204.8-537.6H537.6V307.2h-51.2v179.2H307.2v51.2h179.2v179.2h51.2V537.6h179.2v-51.2z\" data-spm-anchor-id=\"a313x.7781069.0.i2\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol